// ==================================================================
// gHeader_item-down
// ==================================================================
$(function(){

	// pc
	$(".gHeader_item-down").hover(function(){ // hoverしたら下層メニューが出現
		if(window.innerWidth <= 737) { return }
		$(this).toggleClass("gHeader_item-isActive");
	});

	// sp
	$(".gHeader_item-down").click(function(){
		if(window.innerWidth >= 736) { return }
		$(this).toggleClass("gHeader_item-isActive");
		$(this).children(".gHeader_subList").slideToggle(); // アコーディオン部分
	});

});

// ==================================================================
// gHeader_navBtn
// ==================================================================
$(function(){
	$('.gHeader_navBtn').on('click', function(){
		toggle();
	});
});

const open = function() { // gHeader_navBtnを開ける動き
	$('.gHeader_navBtn').addClass('gHeader_navBtn-isActive');
	$('.gHeader_nav').addClass('gHeader_nav-isActive');
}

const close = function() { // gHeader_navBtnを閉める動き
	$('.gHeader_navBtn').removeClass('gHeader_navBtn-isActive');
	$('.gHeader_nav').removeClass('gHeader_nav-isActive');
}

const toggle = function(){ // gHeader_navBtnを開け閉めする動き
	$('.gHeader_navBtn').hasClass('gHeader_navBtn-isActive') ? close() : open(); // .gHeader_btn が .gHeader_btn-isActive を持っていたら外す。持っていなかったらつける。
	// 条件式 ? 条件式がtrueの時の処理 : 条件式がfalseの時の処理;
}

module.exports = { // 定義した関数を他ファイルで使えるようにする
	open,
	close,
	toggle
};